import { Parser } from 'json2csv';

export type CsvRow = Record<string, unknown>;

const toScalar = (value: unknown): string | number | boolean => {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) {
    return value.map((item) => (typeof item === 'object' ? JSON.stringify(item) : String(item))).join('; ');
  }
  if (typeof value === 'object') return JSON.stringify(value);
  return value as string | number | boolean;
};

// Combines heterogeneous rows (scenarios can have different recipe target columns) into a single
// CSV. The field set is the union of every row's keys so no column is dropped, and any non-scalar
// value is flattened to a string so json2csv can serialise it.
export const combineRowsToCsv = (rows: CsvRow[]): string => {
  if (rows.length === 0) return '';
  const fields = Array.from(
    rows.reduce<Set<string>>((set, row) => {
      Object.keys(row).forEach((key) => set.add(key));
      return set;
    }, new Set<string>()),
  );
  const normalised = rows.map((row) => fields.reduce<CsvRow>((acc, field) => {
    acc[field] = toScalar(row[field]);
    return acc;
  }, {}));
  return new Parser({ fields }).parse(normalised);
};

export const downloadCsv = (filename: string, csv: string): void => {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  window.URL.revokeObjectURL(url);
};
